import React from 'react'
import PropTypes from 'prop-types'

import { Typography, Box, Stack } from '@mui/material'
import AttachFileIcon from '@mui/icons-material/AttachFile'

import T from 'T'

import EmailAttachmentsSection from './EmailAttachmentsSection'

const EmailDetailsContent = ({ subject, body, toRecipientEmails, ccRecipientEmails, defaultAttachments, customAttachments }) => {
  const hasAttachments = defaultAttachments.length > 0 || customAttachments.length > 0
  const hasNoContent = !subject && !body && toRecipientEmails.length === 0 && !hasAttachments

  if (hasNoContent) {
    return (
      <Typography variant="body1" color="text.secondary">
        {T.NO_ADDITIONAL_DETAILS}
      </Typography>
    )
  }

  return (
    <Box>
      {subject && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="h6" color="text.primary" fontWeight={600}>
            {T.SUBJECT}
          </Typography>
          <Typography variant="body1" color="text.primary">
            {subject}
          </Typography>
        </Box>
      )}

      {toRecipientEmails.length > 0 && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="h6" color="text.primary" fontWeight={600}>
            {T.TO}
          </Typography>
          <Typography variant="body1" color="text.primary">
            {toRecipientEmails.join(', ')}
          </Typography>
        </Box>
      )}

      {ccRecipientEmails.length > 0 && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="h6" color="text.primary" fontWeight={600}>
            {T.CC}
          </Typography>
          <Typography variant="body1" color="text.primary">
            {ccRecipientEmails.join(', ')}
          </Typography>
        </Box>
      )}

      {body && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="h6" color="text.primary" fontWeight={600} sx={{ display: 'block', mb: 0.5 }}>
            {T.BODY}
          </Typography>
          <Box
            sx={{
              p: 1.5,
              borderRadius: 1,
              bgcolor: 'background.paper',
              border: '1px solid',
              borderColor: 'divider',
              '& *': { margin: 0 },
            }}
            dangerouslySetInnerHTML={{ __html: body }}
          />
        </Box>
      )}

      {hasAttachments && (
        <Box>
          <Stack direction="row" alignItems="center" spacing={0.5} sx={{ mb: 1.5 }}>
            <AttachFileIcon fontSize="small" color="action" />
            <Typography variant="h6" color="text.primary" fontWeight={600}>
              {T.ATTACHMENTS}
            </Typography>
          </Stack>
          <EmailAttachmentsSection title={T.INVOICE} attachments={defaultAttachments} />
          <EmailAttachmentsSection title={T.OTHER_ATTACHMENTS} attachments={customAttachments} />
        </Box>
      )}
    </Box>
  )
}

EmailDetailsContent.propTypes = {
  subject: PropTypes.string,
  body: PropTypes.string,
  toRecipientEmails: PropTypes.array,
  ccRecipientEmails: PropTypes.array,
  defaultAttachments: PropTypes.array,
  customAttachments: PropTypes.array,
}

EmailDetailsContent.defaultProps = {
  subject: '',
  body: '',
  toRecipientEmails: [],
  ccRecipientEmails: [],
  defaultAttachments: [],
  customAttachments: [],
}

export default EmailDetailsContent
